import React from 'react';

// Кубки уровней кешбэка: металлические градиенты по тиру + гравировка-геймпад
// (магазин игровой — кубки тоже про игры). Недостигнутый уровень — серый металл.
export type TrophyTier = 'bronze' | 'silver' | 'gold' | 'platinum' | 'gray';

const PALETTES: Record<TrophyTier, { top: string; mid: string; low: string; dark: string }> = {
  bronze: { top: '#F2B380', mid: '#C77A3B', low: '#99521F', dark: '#8C4A1F' },
  silver: { top: '#F2F5F9', mid: '#C3CBD6', low: '#99A3B0', dark: '#7E8896' },
  gold: { top: '#FFE28E', mid: '#F2B32B', low: '#CE8C15', dark: '#A66B0F' },
  platinum: { top: '#F4FAFF', mid: '#C9DFF2', low: '#93B7D8', dark: '#6E93B5' },
  gray: { top: '#EDEFF2', mid: '#C9CDD3', low: '#A5AAB2', dark: '#8F949C' },
};

export const tierByIndex = (index: number): TrophyTier => {
  const order: TrophyTier[] = ['bronze', 'silver', 'gold', 'platinum'];
  return order[Math.min(index, order.length - 1)];
};

export const TrophyIcon: React.FC<{ tier: TrophyTier; size?: number; reached?: boolean }> = ({
  tier,
  size = 28,
  reached = true,
}) => {
  const key: TrophyTier = reached ? tier : 'gray';
  const p = PALETTES[key];
  const gradId = `trophy-${key}`;

  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true">
      <defs>
        <linearGradient id={gradId} x1="24" y1="5" x2="24" y2="35" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor={p.top} />
          <stop offset="0.55" stopColor={p.mid} />
          <stop offset="1" stopColor={p.low} />
        </linearGradient>
      </defs>

      {/* Ручки */}
      <path
        d="M12 10H8.6C6.6 10 5 11.6 5 13.6c0 4.9 3.4 9 8 10.1M36 10h3.4c2 0 3.6 1.6 3.6 3.6 0 4.9-3.4 9-8 10.1"
        stroke={p.dark}
        strokeWidth="3"
        strokeLinecap="round"
      />

      {/* Обод */}
      <rect x="12" y="5" width="24" height="4.6" rx="2.3" fill={p.dark} />

      {/* Чаша */}
      <path
        d="M13 9h22v9c0 6.6-4.9 11.6-11 11.6S13 24.6 13 18V9z"
        fill={`url(#${gradId})`}
      />

      {/* Блик */}
      <path
        d="M16.6 11.5c-.5 5.4.9 10.2 3.3 13.3"
        stroke="#FFFFFF"
        strokeOpacity="0.38"
        strokeWidth="2.4"
        strokeLinecap="round"
      />

      {/* Гравировка-геймпад */}
      <path
        d="M20 13.6a3.3 3.3 0 0 0 0 6.6h8a3.3 3.3 0 0 0 0-6.6h-8z"
        fill="#FFFFFF"
        fillOpacity="0.88"
      />
      <path d="M20.2 16.9h3M21.7 15.4v3" stroke={p.low} strokeWidth="1.3" strokeLinecap="round" />
      <circle cx="26.6" cy="15.9" r="0.95" fill={p.low} />
      <circle cx="28.2" cy="17.8" r="0.95" fill={p.low} />

      {/* Ножка и подставка */}
      <path d="M21.3 29.4h5.4l1.1 6.6h-7.6l1.1-6.6z" fill={`url(#${gradId})`} />
      <rect x="16" y="36" width="16" height="3.2" rx="1.6" fill={p.mid} />
      <rect x="13" y="39.2" width="22" height="4.3" rx="2.15" fill={p.dark} />

      {/* Искры платины */}
      {key === 'platinum' && (
        <>
          <path d="M40.5 6.5l.9 2.2 2.2.9-2.2.9-.9 2.2-.9-2.2-2.2-.9 2.2-.9.9-2.2z" fill="#BFDCF5" />
          <path d="M6.5 28l.7 1.7 1.7.7-1.7.7-.7 1.7-.7-1.7-1.7-.7 1.7-.7.7-1.7z" fill="#BFDCF5" />
          <path d="M43 21l.5 1.3 1.3.5-1.3.5-.5 1.3-.5-1.3-1.3-.5 1.3-.5.5-1.3z" fill="#D8EAFA" />
        </>
      )}
    </svg>
  );
};
